import type { FC } from 'react'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'
import { RadioGroup } from '@headlessui/react'
import RecipientCard from './RecipientCard'

const RecipientRadioOpt: FC<{
  recipient: GetUsers_getUsers
}> = ({ recipient }) => (
  <RadioGroup.Option className="w-full" value={recipient.cosId}>
    {({ checked }) => <RecipientCard recipient={recipient} checked={checked} />}
  </RadioGroup.Option>
)

export default RecipientRadioOpt
